import { BLINK_FLAGS, FLAGS } from '@thoughtspot/env-flags';
import { getValue } from '@thoughtspot/session-service';
import DOMPurify from 'dompurify';
export const getFlagsFromEventData = (flags) => {
    const result = {};
    flags.forEach((flag) => {
        const sanitizedFlag = DOMPurify.sanitize(flag);
        if (Object.hasOwn(BLINK_FLAGS, sanitizedFlag)) {
            result[sanitizedFlag] = {
                flagId: sanitizedFlag,
                flagValue: getValue(FLAGS[sanitizedFlag] ?? BLINK_FLAGS[sanitizedFlag]),
            };
        }
    });
    return result;
};
//# sourceMappingURL=utils.js.map